import { Injector } from '@angular/core';
import { StoreService } from './store.service';
import { InMemoryStoreService } from './in-memory-store.service';
import { LocalStorageStoreService } from './local-storage-store.service';

const storeFactory = (): StoreService => {
	try {
		localStorage.setItem('___tmp__value', 'test');
		localStorage.removeItem('___tmp__value');
		return new LocalStorageStoreService();
	} catch (e) {}
	return new InMemoryStoreService();
};

// tslint:disable-next-line:variable-name
export const StoreProvider = {
	provide: StoreService,
	useFactory: storeFactory,
	deps: [Injector]
};
